import {
    LayoutDashboard, FileText, Settings, ShieldCheck
} from 'lucide-react';
import logo from '../Logo/logo.png';
import './layout/Sidebar.css';
import { ADMIN_EMAILS } from '../App';

const NAV_ITEMS = [
    { label: 'Dashboard', icon: LayoutDashboard, key: 'dashboard' },
    { label: 'Reports', icon: FileText, key: 'reports' },
    { label: 'Settings', icon: Settings, key: 'settings' },
];

export default function Sidebar({ view, onNavigate, onLogout, company }) {
    const userName = company?.name || company?.company_name || company?.email?.split('@')[0] || 'User';
    const userEmail = company?.emailF || '';
    const initials = userName[0]?.toUpperCase() || 'U';

    return (
        <aside className="sidebar">
            <div className="sidebar-header">
                <img src={logo} alt="" style={{ height: '20px', width: 'auto' }} />
                <span className="sidebar-wordmark">BharatQA</span>
            </div>

            <nav className="sidebar-nav">
                {NAV_ITEMS.map(({ label, icon: Icon, key }) => {
                    const active = view === key || (key === 'dashboard' && (view === 'tests' || view === 'test-detail'));
                    return (
                        <button
                            key={key}
                            className={`sidebar-link ${active ? 'active' : ''}`}
                            onClick={() => onNavigate(key)}
                        >
                            <Icon size={16} />
                            <span>{label}</span>
                        </button>
                    );
                })}
                {company && ADMIN_EMAILS.includes(company.email) && (
                    <button
                        className={`sidebar-link ${view === 'admin' ? 'active' : ''}`}
                        onClick={() => onNavigate('admin')}
                    >
                        <ShieldCheck size={16} />
                        <span>Admin</span>
                    </button>
                )}
            </nav>

            <div className="sidebar-user-footer">
                <div className="sidebar-user-info">
                    <div className="sidebar-user-avatar">
                        {company?.picture ? (
                            <img src={company.picture} alt="" className="user-avatar-img" />
                        ) : (
                            <div className="user-avatar-initial">{initials}</div>
                        )}
                    </div>
                    <div className="sidebar-user-meta">
                        <div className="user-name-text">{userName}</div>
                        <div className="user-email-text">{userEmail}</div>
                        <button className="sidebar-logout-text-link" onClick={onLogout}>
                            Sign out
                        </button>
                    </div>
                </div>
            </div>
        </aside>
    );
}
